module.exports = __webpack_public_path__ + "img/pt.70a47eed.svg";